import { create } from 'zustand';

interface ManageHubModalState {
  slug: string;
  isOpen: boolean;
  onManageHubModalClose: () => void;
  onManageHubModalOpen: (slug: string) => void;
}

export const useManageHubModalStore = create<ManageHubModalState>(set => ({
  isOpen: false,
  slug: '',
  hubId: undefined,
  onManageHubModalClose: () => set({ isOpen: false, slug: '' }),
  onManageHubModalOpen: (slug: string) => set({ isOpen: true, slug }),
}));
